import { StringNode, widget, WidgetPlugin } from '@sagold/react-json-editor';

import { FormField } from '../../../components/formfield/FormField';
import { ReadOnlyInput } from '../../../components/readonly-input/ReadOnlyInput';
import { Textarea } from '../../../components/textarea/Textarea';
import { StringOptions } from '../stringwidget/StringWidget';
import { isNullableString, useErrorTransformation } from '../widgetUtils';

export const TextareaWidget = widget<StringNode<StringOptions>, string>(
  ({ node, options, setValue }) => {
    const errors = useErrorTransformation(node.errors);

    return (
      <FormField
        widgetType="string"
        node={node}
        options={options}
        errors={errors}
        tableLayout={options.tableLayout}
      >
        {options.readOnly ? (
          <ReadOnlyInput
            label={options.title}
            value={node.value}
            tableLayout={options.tableLayout}
          />
        ) : (
          <Textarea
            error={
              errors.length > 0
                ? errors.map((e) => e.message).join('\n')
                : undefined
            }
            label={options.title}
            placeholder={options.placeholder}
            readOnly={options.readOnly}
            required={options.required}
            disabled={options.disabled}
            value={node.value ?? ''}
            onChange={setValue}
            autosize
            minRows={options.readOnly ? 1 : 6}
            maxRows={6}
            tableLayout={options.tableLayout}
          />
        )}
      </FormField>
    );
  }
);

export const TextareaWidgetPlugin: WidgetPlugin = {
  id: 'textarea-widget',
  use: (node) =>
    isNullableString(node.schema.type) && node.schema.format === 'textarea',
  Widget: TextareaWidget,
};
